import ekultur from './ekultur';

const schemas = [
    ekultur
]

export default schemas;